import React from 'react';
import './styles/reviews_page.css';
import PageTitle from '../global/body_components/page_title/page_title';
import PageText from '../global/body_components/page_text/page_text';

export default class ReviewsPage extends React.Component {
  render() {
    return (
      <section id={"reviews_page_content"}>
        <PageTitle content="Reviews" />
        <PageText content="Content to be added later" />
      </section>
    );
  }
}